import { ApolloError } from "@apollo/client";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";
import { useCallback } from "react";
import { ExecutionResult } from "@apollo/react-common";
import {
  MutationUpdateUserProfileArgs,
  UserProfile,
} from "src/types/graphql.d";

interface UpdateUserProfileData {
  updateUserProfile: UserProfile | undefined;
}

interface UpdateUserProfileHook {
  updateUserProfile: (
    userData: MutationUpdateUserProfileArgs
  ) => Promise<ExecutionResult<UpdateUserProfileData>>;
  data: UpdateUserProfileData | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

const UPDATE_USER_PROFILE = gql`
  mutation updateUserProfile(
    $name: String
    $family_name: String
    $gender: String
    $birthdate: String
    $shipping_address: UpdateShippingAddress
  ) {
    updateUserProfile(
      name: $name
      given_name: $name
      family_name: $family_name
      gender: $gender
      birthdate: $birthdate
      shipping_address: $shipping_address
    ) {
      token
    }
  }
`;

const useUpdateUserProfile = ({
  onCompleted,
}: {
  onCompleted: (data: UpdateUserProfileData) => void;
}): UpdateUserProfileHook => {
  const [updateUserProfileMutation, { loading, data, error }] = useMutation<
    UpdateUserProfileData,
    MutationUpdateUserProfileArgs
  >(UPDATE_USER_PROFILE, { onCompleted });

  const updateUserProfile = useCallback(
    (variables: MutationUpdateUserProfileArgs) => {
      return updateUserProfileMutation({ variables });
    },
    [updateUserProfileMutation]
  );

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  return { updateUserProfile, loading, data, error } as UpdateUserProfileHook;
};

export { useUpdateUserProfile };
